import { ElementRef } from '@angular/core';
import { LEGACY_QUOTE_PAGE_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { HOLDINGS_LAYER_DROPDOWN_CONFIG } from 'SecuritiesApp/ts/constants/holdings-overlap.constants';
import { ALL_HOLDINGS, INTERSECT_UNIQUE_HOLDINGS } from 'SecuritiesApp/ts/constants/holdings-table.constants';
import { HoldingsOverlapService } from '../../services/holdings-overlap.service';
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { SecuritiesService } from 'SecuritiesApp/ts/services/securities.service';
import { downloadUrl } from 'NewAngular/utils/download';
import * as i0 from "@angular/core";
import * as i1 from "../../services/holdings-overlap.service";
import * as i2 from "AccountsApp/ts/services/accounts.service";
import * as i3 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i4 from "SecuritiesApp/ts/services/securities.service";
import * as i5 from "../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i6 from "../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i7 from "../../../../../../search/static/search/ts/features/add-button-autocomplete/add-button-autocomplete.component";
import * as i8 from "@angular/common";
import * as i9 from "../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
import * as i10 from "../holdings-comparison-table/holdings-comparison-table.component";
import * as i11 from "../top-holdings/top-holdings.component";
import * as i12 from "../../../../../../../ycharts/static/ts/features/components/dropdowns/single-select-dropdown/single-select-dropdown.component";
import * as i13 from "SecuritiesApp/ts/features/holdings-overlap/components/sector-exposure-comparison/sector-exposure-comparison.component";
import * as i14 from "SecuritiesApp/ts/features/holdings-overlap/components/common-holdings-comparison/common-holdings-comparison.component";
const _c0 = a0 => ({ disabled: a0 });
const _c1 = () => ({ button: "btn btn-secondary dropdown-toggle width-150 d-flex justify-content-between", dropdownContainer: "dropdown mt-1" });
const _c2 = (a0, a1) => [a0, a1];
function HoldingsOverlapComponent_div_10_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 5);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("textContent", "As of " + ctx_r1.secondaryAsOfDate);
} }
function HoldingsOverlapComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15)(1, "div", 16);
    i0.ɵɵelement(2, "div", 17);
    i0.ɵɵelementStart(3, "div", 18);
    i0.ɵɵlistener("click", function HoldingsOverlapComponent_div_10_Template_div_click_3_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.resetSecondarySecurity()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(4, "svg", 19);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, HoldingsOverlapComponent_div_10_div_5_Template, 1, 1, "div", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", ctx_r1.secondarySecurity.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("tooltipTitle", "Edit");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-edit");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.secondarySecurity);
} }
function HoldingsOverlapComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "ycn-add-button-autocomplete", 21);
    i0.ɵɵlistener("submitHandler", function HoldingsOverlapComponent_div_11_Template_ycn_add_button_autocomplete_submitHandler_1_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.secondarySecuritySelectionHandler($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("searchType", "securities_with_holdings");
} }
function HoldingsOverlapComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵelement(1, "label", 23);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", ctx_r1.errorMessage);
} }
function HoldingsOverlapComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24)(1, "div", 25);
    i0.ɵɵtext(2, "Holdings level");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ycn-single-select-dropdown", 26);
    i0.ɵɵlistener("changeHandler", function HoldingsOverlapComponent_div_14_Template_ycn_single_select_dropdown_changeHandler_3_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.holdingsLayerHandler($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("customCssClasses", i0.ɵɵpureFunction0(3, _c1))("config", ctx_r1.holdingsLayerConfig)("selectedValue", ctx_r1.holdingsLayer);
} }
function HoldingsOverlapComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵtext(1, "Get started.");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4, "Add a second security above.");
    i0.ɵɵelementEnd()();
} }
function HoldingsOverlapComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 28)(2, "div", 29)(3, "h3", 30);
    i0.ɵɵtext(4, "Overlap Key Stats");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 31)(6, "table", 32)(7, "tbody")(8, "tr")(9, "th");
    i0.ɵɵtext(10, "Overlap by Weight");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "th");
    i0.ɵɵtext(12, "# of Overlapping Holdings");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(13, "th", 17)(14, "th", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "tr")(16, "td");
    i0.ɵɵelement(17, "span", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "td");
    i0.ɵɵelement(19, "span", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "td");
    i0.ɵɵelement(21, "span", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "td");
    i0.ɵɵelement(23, "span", 33);
    i0.ɵɵelementEnd()()()()()();
    i0.ɵɵelementStart(24, "ycn-sector-exposure-comparison", 34);
    i0.ɵɵlistener("exposureChanged", function HoldingsOverlapComponent_div_18_Template_ycn_sector_exposure_comparison_exposureChanged_24_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.handleExposureChange($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "ycn-common-holdings-comparison-table", 35);
    i0.ɵɵlistener("setSortProperties", function HoldingsOverlapComponent_div_18_Template_ycn_common_holdings_comparison_table_setSortProperties_25_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.commonHoldingsTableSorting = $event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "div", 36)(27, "div", 37);
    i0.ɵɵelement(28, "ycn-holdings-comparison-table", 38);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "div", 37);
    i0.ɵɵelement(30, "ycn-holdings-comparison-table", 38);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(31, "div", 36)(32, "div", 37);
    i0.ɵɵelement(33, "ycn-top-holdings", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "div", 37);
    i0.ɵɵelement(35, "ycn-top-holdings", 40);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(13);
    i0.ɵɵproperty("textContent", "% of " + ctx_r1.primarySecurityName + "'s holdings also in " + ctx_r1.secondarySecurityName);
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", "% of " + ctx_r1.secondarySecurityName + "'s holdings also in " + ctx_r1.primarySecurityName);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", ctx_r1.overlapMetrics.overlap_by_weight);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", ctx_r1.overlapMetrics.overlap_holdings_count);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", ctx_r1.overlapMetrics.primary_shared_holdings_percentage);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", ctx_r1.overlapMetrics.secondary_shared_holdings_percentage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("exposureData", ctx_r1.overlapMetrics.exposure_data)("exposureChartData", ctx_r1.exposureChartData)("selectedExposureView", ctx_r1.selectedExposureView);
    i0.ɵɵadvance();
    i0.ɵɵproperty("primarySecurityId", ctx_r1.primarySecurityId)("primaryDisplaySecurityId", ctx_r1.primarySecurityDisplaySecurityId)("secondarySecurityId", ctx_r1.secondarySecurity.securityId)("secondaryDisplaySecurityId", ctx_r1.secondarySecurity.displaySecurityId)("holdingsLayer", ctx_r1.holdingsLayer);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r1.holdingsType)("title", ctx_r1.primaryRelatedSecurity.name + " Unique Holdings")("comparable", ctx_r1.primaryRelatedSecurity)("disableRemoveFromMenu", true)("intersectOption", ctx_r1.holdingsIntersectionOption)("comparableSecurities", i0.ɵɵpureFunction2(40, _c2, ctx_r1.primaryRelatedSecurity, ctx_r1.secondarySecurity))("holdingsLayer", ctx_r1.holdingsLayer)("flatByHoldingsLayer", true)("showNoHoldingsMessage", true)("showHoldingsDate", false);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("type", ctx_r1.holdingsType)("title", ctx_r1.secondarySecurity.name + " Unique Holdings")("comparable", ctx_r1.secondarySecurity)("disableRemoveFromMenu", true)("intersectOption", ctx_r1.holdingsIntersectionOption)("comparableSecurities", i0.ɵɵpureFunction2(43, _c2, ctx_r1.secondarySecurity, ctx_r1.primaryRelatedSecurity))("holdingsLayer", ctx_r1.holdingsLayer)("flatByHoldingsLayer", true)("showNoHoldingsMessage", true)("showHoldingsDate", false);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("securityId", ctx_r1.primarySecurityId)("displaySecurityId", ctx_r1.primarySecurityDisplaySecurityId)("holdingsLayer", ctx_r1.holdingsLayer);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("securityId", ctx_r1.secondarySecurity.securityId)("displaySecurityId", ctx_r1.secondarySecurity.displaySecurityId)("holdingsLayer", ctx_r1.holdingsLayer);
} }
/**
 * HoldingsOverlapComponent.
 *
 * Component representing the Holdings Overlap tab.
 */
export class HoldingsOverlapComponent {
    constructor(el, holdingsOverlapService, accountsService, featureService, securitiesService) {
        this.el = el;
        this.holdingsOverlapService = holdingsOverlapService;
        this.accountsService = accountsService;
        this.featureService = featureService;
        this.securitiesService = securitiesService;
        this.secondarySecurityName = '';
        this.holdingsLayerConfig = { list: [] };
        this.loading = false;
        this.overlapDataLoaded = false;
        this.overlapMetrics = null;
        this.errorMessage = '';
        this.holdingsType = ALL_HOLDINGS;
        this.holdingsIntersectionOption = INTERSECT_UNIQUE_HOLDINGS;
        this.primaryAsOfDate = '';
        this.secondaryAsOfDate = '';
        this.viewingGenericData = false;
        this.exposureChartData = null;
        this.selectedExposureView = 'sector';
        this.commonHoldingsTableSorting = null;
        this.primarySecurityName = el.nativeElement.getAttribute('primarySecurityName');
        this.primarySecurityId = el.nativeElement.getAttribute('primarySecurityId');
        this.primaryAsOfDate = el.nativeElement.getAttribute('primaryAsOfDate');
        this.primarySecurityType = el.nativeElement.getAttribute('primarySecurityType');
        this.primarySecurityUrl = el.nativeElement.getAttribute('primarySecurityUrl');
        this.primarySecurityDisplaySecurityId = el.nativeElement.getAttribute('primarySecurityDisplaySecurityId');
        this.primaryRelatedSecurity = {
            name: this.primarySecurityName,
            securityId: this.primarySecurityId,
            securityType: this.primarySecurityType,
            url: this.primarySecurityUrl,
            displaySecurityId: this.primarySecurityDisplaySecurityId,
        };
        this.accountsService.getUserPreferences().subscribe((preference) => {
            this.holdingsLayer = preference.holdings_overlap_layer;
            this.selectedExposureView = preference.holdings_overlap_exposure_data;
        });
    }
    ngOnInit() {
        this.accountsService.useGenericData([LEGACY_QUOTE_PAGE_FEATURE]).subscribe((useGenericDataDisplay) => {
            this.viewingGenericData = useGenericDataDisplay;
        });
        this.checkCompareToQueryParam();
    }
    checkCompareToQueryParam() {
        const url = new URL(window.location.href);
        const compareTo = url.searchParams.get('compareTo');
        if (compareTo != null) {
            this.securitiesService.getSecuritiesInfo(compareTo).subscribe((securitiesInfo) => {
                if (securitiesInfo.length > 0) {
                    const securityObject = securitiesInfo[0];
                    this.setSecondarySecuritySelection({
                        displaySecurityId: securityObject.display_security_id,
                        name: securityObject.security_name,
                        securityId: securityObject.security_id,
                        securityType: securityObject.detailed_security_type,
                        url: '', // Not used in this context
                    });
                }
            });
        }
        else {
            this.getUserRelatedSecurities(this.primarySecurityId);
        }
    }
    getUserRelatedSecurities(securityId) {
        this.securitiesService.getUserRelatedSecurities(securityId, true).subscribe({
            next: (securities) => {
                const firstComparable = securities[0];
                this.setSecondarySecuritySelection({
                    displaySecurityId: firstComparable.displaySecurityId,
                    name: firstComparable.name,
                    securityId: firstComparable.securityId,
                    securityType: firstComparable.securityType,
                    url: firstComparable.url,
                });
            },
        });
    }
    fetchOverlapData() {
        this.loading = true;
        this.holdingsOverlapService
            .getOverlapKeyStats(this.primarySecurityId, this.secondarySecurity.securityId, this.holdingsLayer)
            .subscribe({
            next: (stats) => {
                const allowedHoldingLayers = stats.holding_layers;
                this.holdingsLayerConfig = {
                    list: HOLDINGS_LAYER_DROPDOWN_CONFIG.list.filter((opt) => allowedHoldingLayers.includes(opt.value)),
                };
                this.holdingsLayer = stats.current_holding_layer;
                this.loading = false;
                this.overlapDataLoaded = true;
                this.overlapMetrics = stats;
                this.exposureChartData = {
                    sector: stats.sector_chart_data,
                    broad_asset_class: stats.broad_asset_class_chart_data,
                    equity_style: stats.equity_style_chart_data,
                };
                this.errorMessage = '';
                this.secondaryAsOfDate = stats.secondary_as_of_date;
            },
            error: (response) => {
                this.loading = false;
                if (response.error) {
                    this.errorMessage = `${response.error} For questions, please contact support.`;
                }
                else {
                    this.errorMessage = 'An error has occurred. Please try again or contact support.';
                }
            },
        });
    }
    handleExposureChange(exposureViewType) {
        this.selectedExposureView = exposureViewType;
        this.accountsService.putUserPreferences({ holdings_overlap_exposure_data: exposureViewType }).subscribe();
    }
    exportPDF() {
        this.errorMessage = '';
        if (this.viewingGenericData || this.featureService.userHasFeatures(['exportLegacyData'])) {
            const url = this.holdingsOverlapService.getHoldingsOverlapPDFExportUrl(this.primarySecurityId, this.secondarySecurity.securityId, this.holdingsLayer, this.selectedExposureView, this.commonHoldingsTableSorting);
            downloadUrl(url);
        }
        else {
            this.errorMessage = 'Unable to generate overlap report';
        }
    }
    secondarySecuritySelectionHandler(securityObject) {
        if (!securityObject)
            return;
        this.setSecondarySecuritySelection({
            displaySecurityId: securityObject.display_security_id,
            name: securityObject.name,
            securityId: securityObject.search_id,
            securityType: securityObject.type,
            url: securityObject.url,
        });
    }
    setSecondarySecuritySelection(securityObject) {
        this.secondarySecurity = securityObject;
        this.secondarySecurityName = this.secondarySecurity.name;
        this.fetchOverlapData();
        this.updateUrlParameter('compareTo', securityObject.securityId);
    }
    resetSecondarySecurity() {
        this.secondarySecurity = undefined;
        this.overlapDataLoaded = false;
        this.errorMessage = '';
        this.removeUrlParameter('compareTo');
    }
    updateUrlParameter(key, value) {
        const url = new URL(window.location.href);
        url.searchParams.set(key, value);
        window.history.replaceState({}, '', url.toString());
    }
    removeUrlParameter(key) {
        const url = new URL(window.location.href);
        url.searchParams.delete(key);
        window.history.replaceState({}, '', url.toString());
    }
    holdingsLayerHandler(holdingsLayer) {
        if (holdingsLayer !== this.holdingsLayer) {
            this.holdingsLayer = holdingsLayer;
            this.fetchOverlapData();
        }
    }
}
HoldingsOverlapComponent.ɵfac = function HoldingsOverlapComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HoldingsOverlapComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.HoldingsOverlapService), i0.ɵɵdirectiveInject(i2.AccountsService), i0.ɵɵdirectiveInject(i3.FeatureService), i0.ɵɵdirectiveInject(i4.SecuritiesService)); };
HoldingsOverlapComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HoldingsOverlapComponent, selectors: [["ycn-holdings-overlap"]], inputs: { primarySecurityName: "primarySecurityName", primarySecurityId: "primarySecurityId", primarySecurityUrl: "primarySecurityUrl", primarySecurityType: "primarySecurityType", primarySecurityDisplaySecurityId: "primarySecurityDisplaySecurityId" }, standalone: false, decls: 20, vars: 13, consts: [[1, "d-flex", "align-items-baseline", "mb-row"], [1, "mr-20"], [1, "form-label", "form-label-thin", "text-nowrap", "mr-1"], [1, "mt-10"], [1, "d-flex", "align-items-center", "min-height-base", 3, "textContent"], [1, "text-smallest", "text-gray-40", 3, "textContent"], ["class", "form-group-editable mt-10", 4, "ngIf"], ["class", "mt-10", 4, "ngIf"], ["class", "d-flex align-items-baseline mr-20", 4, "ngIf"], [1, "ml-auto", "d-flex"], ["class", "col-auto", 4, "ngIf"], [1, "btn", "btn-secondary", "text-nowrap", "mt-auto", 3, "click", "ngClass", "disabled"], ["class", "get-started border-0 pt-100", 4, "ngIf"], [4, "ngIf"], ["loaderMessage", "Loading Data...", 3, "hidden"], [1, "form-group-editable", "mt-10"], [1, "form-value"], [3, "textContent"], ["ycnTooltip", "", 1, "btn", "btn-circle", "btn-transparent", "btn-edit", 3, "click", "tooltipTitle"], ["ycnIcon", "", 3, "name"], ["class", "text-smallest text-gray-40", 3, "textContent", 4, "ngIf"], [3, "submitHandler", "searchType"], [1, "d-flex", "align-items-baseline", "mr-20"], [1, "form-label", "text-red", 3, "textContent"], [1, "col-auto"], [1, "label", "form-label", "form-label-thin", 2, "margin-bottom", "2px"], [3, "changeHandler", "customCssClasses", "config", "selectedValue"], [1, "get-started", "border-0", "pt-100"], ["data-test-id", "overlap-key-stats", 1, "panel", "panel-data"], [1, "panel-header"], [1, "panel-title"], [1, "panel-content"], [1, "key-stats-table"], [1, "key-stat-title", 3, "textContent"], ["data-test-id", "sector-exposure-comparison-chart", 3, "exposureChanged", "exposureData", "exposureChartData", "selectedExposureView"], ["data-test-id", "common-holdings-comparison-table", 3, "setSortProperties", "primarySecurityId", "primaryDisplaySecurityId", "secondarySecurityId", "secondaryDisplaySecurityId", "holdingsLayer"], [1, "row"], [1, "col-6"], [3, "type", "title", "comparable", "disableRemoveFromMenu", "intersectOption", "comparableSecurities", "holdingsLayer", "flatByHoldingsLayer", "showNoHoldingsMessage", "showHoldingsDate"], ["data-test-id", "primary-top-holdings", 3, "securityId", "displaySecurityId", "holdingsLayer"], ["data-test-id", "secondary-top-holdings", 3, "securityId", "displaySecurityId", "holdingsLayer"]], template: function HoldingsOverlapComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "label", 2);
        i0.ɵɵtext(3, "Security 1:");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelement(5, "div", 4)(6, "div", 5);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(7, "div", 1)(8, "label", 2);
        i0.ɵɵtext(9, "Security 2:");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(10, HoldingsOverlapComponent_div_10_Template, 6, 4, "div", 6)(11, HoldingsOverlapComponent_div_11_Template, 2, 1, "div", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(12, HoldingsOverlapComponent_div_12_Template, 2, 1, "div", 8);
        i0.ɵɵelementStart(13, "div", 9);
        i0.ɵɵtemplate(14, HoldingsOverlapComponent_div_14_Template, 4, 4, "div", 10);
        i0.ɵɵelementStart(15, "button", 11);
        i0.ɵɵlistener("click", function HoldingsOverlapComponent_Template_button_click_15_listener() { return ctx.exportPDF(); });
        i0.ɵɵtext(16, " Export PDF ");
        i0.ɵɵelementEnd()()();
        i0.ɵɵtemplate(17, HoldingsOverlapComponent_div_17_Template, 5, 0, "div", 12)(18, HoldingsOverlapComponent_div_18_Template, 36, 46, "div", 13);
        i0.ɵɵelement(19, "ycn-loading-symbol", 14);
    } if (rf & 2) {
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("textContent", ctx.primarySecurityName);
        i0.ɵɵadvance();
        i0.ɵɵproperty("textContent", "As of " + ctx.primaryAsOfDate);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.secondarySecurity);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.secondarySecurity);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.errorMessage.length > 0);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.secondarySecurity && ctx.holdingsLayerConfig.list.length > 1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c0, !ctx.overlapDataLoaded))("disabled", !ctx.overlapDataLoaded);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.secondarySecurity);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loading && ctx.overlapDataLoaded);
        i0.ɵɵadvance();
        i0.ɵɵproperty("hidden", !ctx.loading);
    } }, dependencies: [i5.LoadingSymbolComponent, i6.IconDirective, i7.AddButtonAutocompleteComponent, i8.NgClass, i8.NgIf, i9.TooltipDirective, i10.HoldingsComparisonTableComponent, i11.TopHoldingsComponent, i12.SingleSelectDropdownComponent, i13.SectorExposureComparisonChart, i14.CommonHoldingsComparisonTableComponent], encapsulation: 2 });
